(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["rocoxia-discount-code"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('rocoxia-discount-code')) {
  customElements.define('rocoxia-discount-code', class extends HTMLElement {
    connectedCallback() {
      if (this.bound) return;
      this.bound = true;
      this.button = this.querySelector('[data-copy]');
      this.label = this.querySelector('[data-copy-label]');
      this.status = this.querySelector('[data-status]');
      this.originalLabel = this.label.textContent;
      this.button.addEventListener('click', () => this.copy());
    }
    async copy() {
      if (this.busy) return;
      this.busy = true;
      this.button.setAttribute('aria-busy', 'true');
      const code = this.querySelector('[data-code]').textContent.trim();
      let copied = false;
      try {
        if (navigator.clipboard && window.isSecureContext) {
          await navigator.clipboard.writeText(code);
          copied = true;
        }
      } catch (_) {}
      if (!copied) {
        const input = document.createElement('textarea');
        input.value = code;
        input.readOnly = true;
        input.style.cssText = 'position:fixed;left:-9999px;top:0;font-size:16px';
        document.body.appendChild(input);
        input.select();
        input.setSelectionRange(0, code.length);
        try { copied = document.execCommand('copy'); } catch (_) {}
        input.remove();
        this.button.focus({ preventScroll: true });
      }
      clearTimeout(this.resetTimer);
      this.label.textContent = copied ? this.button.dataset.copied : this.originalLabel;
      this.status.textContent = copied ? '' : this.button.dataset.error;
      this.button.removeAttribute('aria-busy');
      this.busy = false;
      if (copied) this.resetTimer = setTimeout(() => {
        this.label.textContent = this.originalLabel;
        this.status.textContent = '';
      }, 4500);
    }
    disconnectedCallback() { clearTimeout(this.resetTimer); }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["rocoxia-us-stock-badge"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('rocoxia-us-delivery')) {
  class RocoxiaUSDelivery extends HTMLElement {
    connectedCallback() {
      this.cleanups = [];
      this.refreshDate = this.refreshDate.bind(this);
      this.subscribe = this.subscribe.bind(this);
      this.refreshDate();
      this.subscribe();
      window.addEventListener('load', this.subscribe, { once: true });
      window.addEventListener('pageshow', this.refreshDate);
      document.addEventListener('visibilitychange', this.refreshDate);
      this.timer = window.setInterval(this.refreshDate, 3600000);
    }

    disconnectedCallback() {
      this.cleanups.forEach(cleanup => cleanup());
      window.removeEventListener('load', this.subscribe);
      window.removeEventListener('pageshow', this.refreshDate);
      document.removeEventListener('visibilitychange', this.refreshDate);
      window.clearInterval(this.timer);
    }

    closureDates(value, country) {
      return new Set((value || '').split(/[\s,;]+/).filter(entry => {
        return country ? entry.startsWith(`${country}:`) : /^\d{4}-\d{2}-\d{2}$/.test(entry);
      }).map(entry => country ? entry.slice(country.length + 1) : entry));
    }

    addDays(date, count, businessDays = false, closures = new Set()) {
      const result = new Date(date);
      let added = 0;
      while (added < count) {
        result.setUTCDate(result.getUTCDate() + 1);
        if (!businessDays || (result.getUTCDay() !== 0 && result.getUTCDay() !== 6 && !closures.has(result.toISOString().slice(0, 10)))) added++;
      }
      return result;
    }

    deliveryRange(today) {
      const processingClosures = this.closureDates(this.dataset.processingClosures);
      const transitClosures = this.closureDates(this.dataset.transitClosures, this.dataset.country);
      const businessDays = this.dataset.businessDays === 'true';
      const days = key => Math.min(60, Math.max(0, Number(this.dataset[key]) || 0));
      const processingMin = days('processingMin');
      const processingMax = Math.max(processingMin, days('processingMax'));
      const transitMin = days('transitMin');
      const transitMax = Math.max(transitMin, days('transitMax'));
      const start = this.addDays(this.addDays(today, processingMin, true, processingClosures), transitMin, businessDays, transitClosures);
      const end = this.addDays(this.addDays(today, processingMax, true, processingClosures), transitMax, businessDays, transitClosures);
      return [start, this.addDays(end, days('peakDays'))];
    }

    refreshDate() {
      const parts = new Intl.DateTimeFormat('en-US', {
        timeZone: 'America/Los_Angeles', year: 'numeric', month: '2-digit', day: '2-digit'
      }).formatToParts(new Date());
      const value = type => Number(parts.find(part => part.type === type).value);
      const today = new Date(Date.UTC(value('year'), value('month') - 1, value('day'), 12));
      const [start, end] = this.deliveryRange(today);
      const formatter = new Intl.DateTimeFormat(this.dataset.locale || 'en', {
        month: 'short', day: 'numeric', timeZone: 'UTC'
      });
      const dateNode = this.querySelector('[data-delivery-date]');
      if (dateNode) dateNode.textContent = formatter.formatRange(start, end);
      const prefixNode = this.querySelector('[data-delivery-prefix]');
      if (prefixNode) prefixNode.textContent = this.dataset.prefix;
    }

    subscribe() {
      const bus = window.theme?.pubsub;
      if (this.cleanups.length || !bus?.subscribe) return;
      const events = bus.PUB_SUB_EVENTS;
      this.cleanups.push(bus.subscribe(events.optionValueSelectionChange, message => {
        const target = message?.data?.event?.target;
        const owner = target?.closest('product-info');
        if (owner?.getAttribute('form') === this.dataset.formId) this.hidden = true;
      }));
      this.cleanups.push(bus.subscribe(events.variantChange, message => {
        const data = message?.data;
        if (String(data?.sectionId) !== this.dataset.sectionId || String(data?.productId) !== this.dataset.productId) return;
        const fresh = data.parsedHTML?.getElementById(this.id);
        this.hidden = !data.variant?.available || !fresh || fresh.hasAttribute('hidden');
        this.refreshDate();
      }));
    }
  }
  customElements.define('rocoxia-us-delivery', RocoxiaUSDelivery);
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["rocoxia-v310-navigation"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('rocoxia-pdp-nav'))customElements.define('rocoxia-pdp-nav',class extends HTMLElement{
connectedCallback(){this.controller?.abort();this.controller=new AbortController();const signal=this.controller.signal,surface=this.querySelector('nav'),rail=this.querySelector('.rv310-nav-links'),prev=this.querySelector('[data-nav-prev]'),next=this.querySelector('[data-nav-next]');let entries=[],last=null,frame;const motion=()=>matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth';
const resolve=key=>{try{if(key==='reviews'){const widget=document.querySelector(this.dataset.reviewSelector||'#looxReviews')||document.querySelector('[id^="LOOX-V2_CAROUSEL-"],.loox-reviews-default');if(!widget)return null;return document.querySelector('[data-rocoxia-anchor="reviews"]')||widget}return document.querySelector('[data-rocoxia-anchor="'+key+'"]')}catch{return null}};
const arrows=()=>{const max=rail.scrollWidth-rail.clientWidth;prev.hidden=next.hidden=max<2;prev.disabled=Math.abs(rail.scrollLeft)<2;next.disabled=Math.abs(rail.scrollLeft)>=max-2};
const update=()=>{if(this.hidden||getComputedStyle(this).display==='none'){this.classList.remove('is-fixed');this.style.height='';return;}let top=0;if(!matchMedia('(max-width: 760px)').matches)document.querySelectorAll('sticky-header,#shopify-section-header,.header-section').forEach(h=>{const r=h.getBoundingClientRect(),pos=getComputedStyle(h).position;if((pos==='fixed'||pos==='sticky')&&r.top<=1&&r.bottom>0&&r.height<250)top=Math.max(top,r.bottom)});this.style.setProperty('--nav-top',top+'px');const rect=this.getBoundingClientRect();this.classList.toggle('is-fixed',rect.top<top);this.style.height=surface.offsetHeight+'px';let active=null;for(const item of entries)if(item.target.getBoundingClientRect().top<=top+surface.offsetHeight+100)active=item;entries.forEach(item=>{if(item===active)item.link.setAttribute('aria-current','location');else item.link.removeAttribute('aria-current')});if(active&&last!==active){const a=active.link.getBoundingClientRect(),r=rail.getBoundingClientRect();rail.scrollBy({left:a.left+a.width/2-r.left-r.width/2,behavior:motion()})}last=active;arrows()};
const schedule=()=>{cancelAnimationFrame(frame);frame=requestAnimationFrame(update)};
const sync=()=>{entries=[];this.querySelectorAll('[data-rocoxia-target]').forEach(link=>{const target=resolve(link.dataset.rocoxiaTarget);link.hidden=!target||!!target.closest('[hidden]')||getComputedStyle(target).display==='none';if(!link.hidden){if(!target.id)target.id='Rocoxia-'+link.dataset.rocoxiaTarget+'-target';link.href='#'+target.id;entries.push({link,target})}});this.hidden=!entries.length;document.querySelectorAll('.rv310-details-link').forEach(link=>{const target=resolve('details');link.hidden=!target;if(target)link.href='#'+target.id});schedule()};
prev.addEventListener('click',()=>rail.scrollBy({left:-rail.clientWidth*.7*(getComputedStyle(rail).direction==='rtl'?-1:1),behavior:motion()}),{signal});next.addEventListener('click',()=>rail.scrollBy({left:rail.clientWidth*.7*(getComputedStyle(rail).direction==='rtl'?-1:1),behavior:motion()}),{signal});rail.addEventListener('scroll',arrows,{signal,passive:true});this.addEventListener('click',e=>{const item=entries.find(x=>x.link===e.target.closest('a'));if(!item)return;e.preventDefault();const top=parseFloat(this.style.getPropertyValue('--nav-top'))||0;window.scrollTo({top:item.target.getBoundingClientRect().top+scrollY-top-surface.offsetHeight-18,behavior:motion()});history.replaceState(null,'','#'+item.target.id);item.target.tabIndex=-1;item.target.focus({preventScroll:true})},{signal});window.addEventListener('scroll',schedule,{signal,passive:true});window.addEventListener('resize',schedule,{signal});document.addEventListener('shopify:section:load',sync,{signal});document.addEventListener('shopify:section:unload',sync,{signal});this.observer=new MutationObserver(sync);this.observer.observe(document.body,{childList:true,subtree:true});this.resizeObserver=new ResizeObserver(schedule);this.resizeObserver.observe(surface);this.cleanup=()=>cancelAnimationFrame(frame);sync();}
disconnectedCallback(){this.controller?.abort();this.observer?.disconnect();this.resizeObserver?.disconnect();this.cleanup?.()}
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["rocoxia-v310-pdp-ui"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('rv310-video'))customElements.define('rv310-video',class extends HTMLElement{
connectedCallback(){this.controller?.abort();this.controller=new AbortController();const signal=this.controller.signal,v=this.querySelector('video'),b=this.querySelector('button');if(!v||!b)return;const syncRatio=()=>{if(v.videoWidth&&v.videoHeight)this.style.setProperty('--video-native-ratio',v.videoWidth+'/'+v.videoHeight)};v.addEventListener('loadedmetadata',syncRatio,{signal});syncRatio();b.hidden=false;b.addEventListener('click',()=>{v.play().catch(()=>{b.hidden=false})},{signal});v.addEventListener('play',()=>b.hidden=true,{signal});v.addEventListener('pause',()=>b.hidden=false,{signal})}disconnectedCallback(){this.controller?.abort()}
});
if (!customElements.get('rv310-light')) customElements.define('rv310-light', class extends HTMLElement {
  connectedCallback() {
    this.controller?.abort(); this.controller = new AbortController();
    const button = this.querySelector('button'); if (!button) return;
    button.addEventListener('click', () => {
      const on = button.getAttribute('aria-pressed') !== 'true';
      this.querySelector('.rv310-light-on').hidden = !on;
      button.setAttribute('aria-pressed', String(on));
      button.setAttribute('aria-label', on ? button.dataset.labelOff : button.dataset.labelOn);
      this.querySelector('.rv310-light-hint').hidden = true;
    }, {signal:this.controller.signal});
  }
  disconnectedCallback() { this.controller?.abort(); }
});
if (!customElements.get('rv310-difficulty')) customElements.define('rv310-difficulty', class extends HTMLElement {
  connectedCallback() {
    this.controller?.abort(); this.controller = new AbortController();
    const range=this.querySelector('input'), buttons=[...this.querySelectorAll('[data-level]')], reset=this.querySelector('.rv310-reset');
    const show=()=>{const value=Number(range.value);this.querySelectorAll('[data-pace]').forEach(p=>p.hidden=Number(p.dataset.pace)!==value);buttons.forEach(b=>b.setAttribute('aria-pressed',String(Number(b.dataset.level)===value)));range.setAttribute('aria-valuetext',buttons[value].textContent.trim());reset.hidden=value===Number(this.dataset.current)};
    range.addEventListener('input',show,{signal:this.controller.signal});
    buttons.forEach(b=>b.addEventListener('click',()=>{range.value=b.dataset.level;show()},{signal:this.controller.signal}));
    reset.addEventListener('click',()=>{range.value=this.dataset.current;show()},{signal:this.controller.signal});show();
  }
  disconnectedCallback(){this.controller?.abort()}
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["rocoxia-v310-product-tabs"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('rocoxia-product-tabs'))customElements.define('rocoxia-product-tabs',class extends HTMLElement{
  connectedCallback(){
    this.controller?.abort();this.controller=new AbortController();const signal=this.controller.signal;
    const panels=[...this.querySelectorAll('[data-rxt-panel]')],nav=this.querySelector('.rxt-nav');if(!panels.length||!nav)return;
    nav.replaceChildren();const tabs=panels.map((panel,i)=>{
      const button=document.createElement('button');button.type='button';button.className='rxt-tab';button.id=panel.id+'-tab';button.textContent=panel.dataset.label;button.setAttribute('role','tab');button.setAttribute('aria-controls',panel.id);
      panel.setAttribute('role','tabpanel');panel.setAttribute('aria-labelledby',button.id);panel.tabIndex=0;panel.querySelector('.rxt-fallback').hidden=true;nav.append(button);return button;
    });
    const sync=()=>panels.forEach(panel=>{if(panel.hidden)return;const rail=panel.querySelector('.rxt-grid'),max=rail.scrollWidth-rail.clientWidth,offset=Math.abs(rail.scrollLeft);panel.querySelector('.rxt-controls').hidden=max<3;panel.querySelector('[data-rxt-prev]').disabled=offset<3;panel.querySelector('[data-rxt-next]').disabled=offset>=max-3;});
    panels.forEach(panel=>{const rail=panel.querySelector('.rxt-grid');rail.addEventListener('scroll',sync,{signal,passive:true});for(const [selector,direction] of [['[data-rxt-prev]',-1],['[data-rxt-next]',1]])panel.querySelector(selector).addEventListener('click',()=>{const step=rail.querySelector('.rxt-card').getBoundingClientRect().width+10;rail.scrollBy({left:step*direction*(getComputedStyle(rail).direction==='rtl'?-1:1),behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'})},{signal});});
    this.observer?.disconnect();this.observer=new ResizeObserver(sync);this.observer.observe(this);
    const activate=index=>{tabs.forEach((tab,i)=>{tab.setAttribute('aria-selected',String(i===index));tab.tabIndex=i===index?0:-1;panels[i].hidden=i!==index});sync();};
    tabs.forEach((tab,i)=>{tab.addEventListener('click',()=>activate(i),{signal});tab.addEventListener('keydown',event=>{let next=i;const rtl=getComputedStyle(this).direction==='rtl';if(event.key==='ArrowRight')next=(i+(rtl?-1:1)+tabs.length)%tabs.length;else if(event.key==='ArrowLeft')next=(i+(rtl?1:-1)+tabs.length)%tabs.length;else if(event.key==='Home')next=0;else if(event.key==='End')next=tabs.length-1;else return;event.preventDefault();activate(next);tabs[next].focus()},{signal})});
    nav.hidden=false;this.dataset.enhanced='true';activate(0);
  }
  disconnectedCallback(){this.controller?.abort();this.observer?.disconnect()}
});
  } catch(e) { console.error(e); }
})();

})();
